import CheckBox from 'components/final-form/CheckBox';
import { DropdownOption } from 'components/final-form/dropdownUtils';
import Input from 'components/final-form/Input';
import RadioGroup from 'components/final-form/RadioGroup';
import PraxFormGrid from 'components/layout/PraxFormGrid';
import GuarantorDropdownSegment from 'components/treatments/segments/GuarantorDropdownSegment';
import React from 'react';
import { Field } from 'react-final-form';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Grid, RadioProps } from 'semantic-ui-react';

interface Props extends MessageSourceProps {
  billReceivers: Array<RadioProps>,
  guarantors: Array<DropdownOption>,
  tariffType?: string,
  guarantorId?: number,
  readOnly: boolean
}

const BillOptionsSegment = (props: Props) => {

  const {
    getMessage,
    billReceivers,
    guarantors,
    guarantorId,
    readOnly,
    tariffType
  } = props;

  return (
      <PraxFormGrid style={{marginBottom: "0.75rem"}} columns={5} verticalAlign="middle">
        <Grid.Row>
          <Grid.Column verticalAlign="middle">
            <h4>{getMessage('treatmentForm.billOptions')}</h4>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={3} verticalAlign="middle">
            {getMessage('treatmentForm.billReceiver')}
          </Grid.Column>
          <Grid.Column width={5} verticalAlign="middle">
            <Field name="bill"
                   component={RadioGroup}
                   radioDefinitions={billReceivers}
                   radiowidth="40%"
                   disabled={readOnly}
            />
          </Grid.Column>
          <Grid.Column width={3} verticalAlign="middle">
            <Field
                name="guarantorDoctor"
                component={CheckBox}
                label={getMessage('guarantor')}
                disabledWhenFalse
                disabled={readOnly}
            />
          </Grid.Column>
          <Grid.Column width={5} verticalAlign="middle">
            <Field
                name="docPrinted"
                component={CheckBox}
                label={getMessage('treatmentForm.invoicePractice')}
                disabled={readOnly}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={3} verticalAlign="middle">
            {getMessage('guarantor')}
          </Grid.Column>
          <Grid.Column width={8} verticalAlign="middle">
            <GuarantorDropdownSegment
                guarantors={guarantors}
                guarantorId={guarantorId}
                tariffType={tariffType}
                readOnly={readOnly}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={3} verticalAlign="middle">
            {getMessage('treatmentForm.mtglnum')}
          </Grid.Column>
          <Grid.Column width={5} verticalAlign="middle">
            <Field
                name="mtgNumber"
                component={Input}
                disabled={readOnly}
                fluid
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={3} verticalAlign="middle">
            {getMessage('treatmentForm.surchargeDiscount')}
          </Grid.Column>
          <Grid.Column width={5} verticalAlign="middle">
            <Field
                name="discount"
                component={Input}
                icon="percent"
                disabled={readOnly}
                fluid
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={3} verticalAlign="middle">
            {getMessage('treatmentForm.installment')}
          </Grid.Column>
          <Grid.Column width={5} verticalAlign="middle">
            <Field
                name="advanceAmount"
                component={Input}
                disabled={readOnly}
                fluid
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={3} verticalAlign="middle">
            {getMessage('treatmentForm.remarks')}
          </Grid.Column>
          <Grid.Column width={13} verticalAlign="middle">
            <Field
                name="remark"
                component={Input}
                disabled={readOnly}
                fluid
            />
          </Grid.Column>
        </Grid.Row>
      </PraxFormGrid>
  );
};

export default withMessages(BillOptionsSegment);
